import './bootstrap';
import Notify from 'simple-notify';
import 'simple-notify/dist/simple-notify.min.css';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4'
import languageNL from 'datatables.net-plugins/i18n/nl-NL.mjs';
import { Select2 } from 'select2';
import smartWizard from 'smartwizard';
import swal from 'sweetalert';
import * as Sentry from "@sentry/browser";

if (typeof sentry_dsn !== 'undefined') {
    Sentry.init({
        dsn: sentry_dsn,
        release: app_version
    });
}

try {
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('bootstrap');
    require('cropit');
    require("magnific-popup");
} catch (e) {}

window.addSpinner = function addSpinner($el) {
    $el.append(`<div class="modal-loader-wrapper text-center my-5">
                    <i class="mdi mdi-spin mdi-36px mdi-loading"></i>
                </div>`);
}

window.initSelect2 = function initSelect2($el) {
    if (typeof $el === 'undefined') {
        $el = $(document.body);
    }

    $el.find('.select2').select2({
        dropdownParent: $el,
        minimumResultsForSearch: 5
    });
};

window.initTooltips = function initTooltips($el) {
    if (typeof $el === 'undefined') {
        $el = $(document.body);
    }

    $el.find('[data-bs-toggle="tooltip"]').tooltip();
};

(function ($) {
    'use strict';

    function initHoriMenuActive() {
        $(".navbar-nav a").each(function () {
            var pageUrl = window.location.href.split(/[?#]/)[0];
            if (this.href == pageUrl) {
                $(this).addClass("active");
                $(this).parents('.nav-link').addClass("active");
            }
        });
    }

    function initComponents() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl)
        })

        // Counter Up
        var delay = $(this).attr('data-delay') ? $(this).attr('data-delay') : 100; //default is 100
        var time = $(this).attr('data-time') ? $(this).attr('data-time') : 1200; //default is 1200
        $('[data-plugin="counterup"]').each(function (idx, obj) {
            $(this).counterUp({
                delay: delay,
                time: time
            });
        });
    }

    function initPreloader() {
        $(window).on('load', function () {
            $('#status').fadeOut();
            $('#preloader').delay(350).fadeOut('slow');
        });
    }

    function initFormValidation() {
        $('form.needs-validation').each(function(){
            let $form = $(this);

            $(this).find('button[type="submit"],input[type="submit"]').on('click', function(event){
                $form[0].checkValidity();

                $form.addClass('was-validated');
            });
        });
    }

    function initTinymce() {
        tinymce.defaultSettings = {
            height: 300,
            plugins: [
                "autoresize advlist autolink link image lists charmap hr anchor pagebreak spellchecker",
                "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking",
                "save table directionality emoticons template paste"
            ],
            // paste_as_text: true,
            paste_block_drop: true,
            autoresize_bottom_margin: 10,
            toolbar: "insertfile undo redo | pastetext | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | forecolor backcolor emoticons",
            menubar: false,
            statusbar: false,
            relative_urls: false,
            remove_script_host: true,
            document_base_url: app_base_url,
            init_instance_callback : function(editor) {
                window.setTimeout(function(){
                    let editorH = editor.editorContainer.offsetHeight;
                    let editorW = editor.editorContainer.offsetWidth;

                    $(editor.targetElm)
                        .css({
                            'position':'absolute',
                            'height': editorH,
                            'width': editorW
                        })
                        .show();

                    editor.on('change', function () {
                        tinymce.triggerSave();
                    });
                }, 10);
            },
        };
    }

    function initDatatables() {
        $.extend($.fn.dataTableExt.oStdClasses, {
            datatable_length: 'form-select form-select-sm'
        });

        $.extend($.fn.dataTable.defaults, {
            language: languageNL
        });

        $('.datatable').DataTable({
            responsive: true,
            language: languageNL
        });
    }

    function initFlashNotify() {
        $('#flashes .alert').each(function() {
            new Notify({
                status: $(this).data('status'),
                title: $(this).text(),
                autoclose: true,
                position: 'right bottom'
            });
        });
    }

    function initHoverableDropdowns() {
        $('.dropdown-hover').each(function(){
            let dropdownButton = $(this).find('[data-bs-toggle="dropdown"]');
            let instance = bootstrap.Dropdown.getOrCreateInstance(dropdownButton);

            $(this).on('mouseenter', function() {
                instance.show();
            }).on('mouseleave', function() {
                instance.hide();
            });
        });
    }

    function init() {
        initHoriMenuActive();
        initComponents();
        initPreloader();
        initFormValidation();
        initTinymce();
        initDatatables();
        initFlashNotify();
        initSelect2();
        initHoverableDropdowns();
    }
    init();
})(jQuery);


// Add CSRF token to AJAX requests
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).on('click', '.select-image-btn', function (e) {
  $(this).parents('.cropit-container').find('.cropit-image-input').trigger('click');
});

$(function(){
    rightColumnStickyPosition();

    $(window).on('resize', function(e){
        rightColumnStickyPosition();
    });
});


// When opening a modal, if the relatedTarget has a content_route data
// attribute, load the route into it's .modal-body
$(document).on('show.bs.modal', function(e){
    let route = $(e.relatedTarget).attr('data-content_route');
    let modal = e.target;
    if(typeof route === 'undefined'){
        return;
    }

    $(e.target).find('.modal-content').empty();
    addSpinner($(e.target).find('.modal-content'));
    $(e.target).find('.modal-content').load(route, function(){
        // Init select2 in modal
        initSelect2($(this));

        // Init tooltips in modal
        initTooltips($(this));

        // Trigger the modal_content_loaded event
        $(modal).trigger('modal_content_loaded');
    });
});

function rightColumnStickyPosition() {
    if ($('#right_column_sticky').length === 0) {
        return;
    }

    let headerHeight = $('header#page-topbar > .top-navigation').height();
    $('#right_column_sticky').css('top', (headerHeight + 24) + 'px');
}

let startTime;
window.startTimeRegistration = function startTimeRegistration() {
    // Do not register time for LTI guest user
    if (is_lti_guest_user) {
        return;
    }

    startTime = new Date();

    // Save time registration every time_reg_logging_interval seconds
    window.setInterval(function(){
        saveTimeRegistration();
    }, time_reg_logging_interval);

    // Save time registration when the window gets hidden
    document.addEventListener("visibilitychange", (event) => {
        if (document.visibilityState === "hidden") {
            saveTimeRegistration();
        }
    });
}

window.saveTimeRegistration = async function saveTimeRegistration() {
    // Do not register time for LTI guest user
    if (is_lti_guest_user) {
        return;
    }

    let addtime = Math.floor((new Date() - startTime) / 1000);
    if (addtime < 5) {
        return;
    }

    // Send time to add to the timeregistration to the server
    let promise = fetch(route('users.save_time_registration', user_id), {
        keepalive: true,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        body: JSON.stringify({
                time_registrationable_type: time_registrationable_type,
                time_registrationable_id: time_registrationable_id,
                addtime: addtime,
                completed: timereg_completed ? 1 : 0
            }),
    }).then((response) => response.json())
        .then((responseJson) => {
            if (responseJson.completed && responseJson.time >= time_reg_completion_time) {
                // Mark checkbox as completed, if completed and registered time > time_reg_completion_time
                $('#module_component_overview input[data-type='+JSON.stringify(responseJson.time_registrationable_type)+'][data-id="'+responseJson.time_registrationable_id+'"]').prop('checked', true);
            }
        });

    // Reset startTime
    startTime = new Date();

    return promise;
}

/**
 * Handle the confirmation dialog for forms that require it
 */
$(document).on('submit', 'form', function(e, wasTriggered){
    let $form = $(e.target);

    // No confirmation required
    if (typeof $form.data('confirmation') === 'undefined' || !$form.data('confirmation').length) {
        return true
    }

    // Triggered by script
    if (wasTriggered) {
        return true;
    }

    let isAjaxTable = $form.parents('table').hasClass('ajax-table');

    // Confirmation is required, stop submitting of form
    e.preventDefault();
    e.stopPropagation();

    // Show confirmation dialog
    swal({
        title: "Weet je het zeker?",
        text: $form.data('confirmation'),
        icon: "warning",
        buttons: ['Annuleren', 'Verwijderen'],
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete) {
            if (!isAjaxTable) {
                // Force trigger submit
                $form.trigger('submit', true);
            } else {
                // Send ajax request for destroying the object
                $.ajax({
                    type: 'POST',
                    url: $form.attr('action'),
                    data: {
                        "_method": "DELETE",
                        "_token": $form.find('input[name="_token"]').val()
                    },
                    dataType: 'json',
                    success: function(data){
                        // Show feedback
                        new Notify({
                            status: 'success',
                            title: 'Verwijderen geslaagd',
                            autoclose: true,
                            position: 'right bottom'
                        });

                        // Reload datatable
                        let tableId = $form.parents('table').attr('id');

                        window.LaravelDataTables[tableId].draw(false);
                    },
                    error: function(jqXHR){
                        // Show feedback
                        new Notify({
                            status: 'danger',
                            title: 'Er is iets misgegaan met het verwijderen. Probeer het nogmaals.',
                            autoclose: true,
                            position: 'right bottom'
                        });
                    }
                });
            }
        }
    });
});
